function cov_thy2s29al() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Popular.tsx";
  var hash = "541157dd1209c3a33d0236fddb649291f6daebc3";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Popular.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 47
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "541157dd1209c3a33d0236fddb649291f6daebc3"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_thy2s29al = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_thy2s29al();
var Icon = (cov_thy2s29al().s[0]++, {
  name: 'popular',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.79218 4.57293C9.94897 4.22319 10.154 3.90962 10.4314 3.63223C10.7088 3.3669 11.0223 3.14982 11.3721 2.99304C11.5771 2.89655 11.7821 2.83625 11.9992 2.80007C11.7821 2.75183 11.5771 2.69153 11.3721 2.60711C11.0223 2.45032 10.7088 2.2453 10.4314 1.96791C10.154 1.70258 9.93691 1.37695 9.79218 1.02721C9.6957 0.822181 9.6354 0.617156 9.59922 0.40007C9.55098 0.617156 9.49068 0.822181 9.40625 1.02721C9.24947 1.37695 9.03238 1.69052 8.76706 1.96791C8.50173 2.2453 8.1761 2.46238 7.82635 2.60711C7.62133 2.70359 7.4163 2.76389 7.19922 2.80007C7.4163 2.84831 7.62133 2.90861 7.82635 2.99304C8.1761 3.14982 8.48967 3.3669 8.76706 3.63223C9.04445 3.89756 9.26153 4.22319 9.40625 4.57293C9.50274 4.77796 9.56304 4.98299 9.59922 5.20007C9.64746 4.98299 9.70776 4.77796 9.79218 4.57293ZM5.18593 10.3457C5.4995 9.64615 5.90955 9.01902 6.46432 8.46425C7.0191 7.93359 7.64623 7.49942 8.34573 7.18585C8.75578 6.99289 9.16583 6.87229 9.6 6.79992C9.16583 6.70344 8.75578 6.58284 8.34573 6.41399C7.64623 6.10043 7.0191 5.69038 6.46432 5.1356C5.90955 4.60495 5.47538 3.95369 5.18593 3.2542C4.99297 2.84415 4.87236 2.43409 4.8 1.99992C4.70352 2.43409 4.58291 2.84415 4.41407 3.2542C4.1005 3.95369 3.66633 4.58083 3.13568 5.1356C2.60503 5.69038 1.95377 6.12455 1.25427 6.41399C0.844221 6.60696 0.434171 6.72756 0 6.79992C0.434171 6.89641 0.844221 7.01701 1.25427 7.18585C1.95377 7.49942 2.5809 7.93359 3.13568 8.46425C3.69045 8.9949 4.12462 9.64615 4.41407 10.3457C4.60704 10.7557 4.72764 11.1658 4.8 11.5999C4.89648 11.1658 5.01709 10.7557 5.18593 10.3457Z\" fill=\"currentColor\" />"
});
export default Icon;